var _style, _symbol, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAzureVirtual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 90",
    style: {
      enableBackground: "new 0 0 130 90"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#0078D7;}\r\n")), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    viewBox: "-42.5 -40 85 80"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M37.3,40h-75.2c-2.6-0.1-4.6-2.3-4.5-4.9v-53.6c0-2.6,2-4.7,4.5-4.9h25.7c2.8-10-0.9-11.4-17.2-11.4V-40h55.4 v5.3c-16.4,0-18,1.4-15.2,11.4h26.6c2.5,0,5.2,2.3,5.2,4.9v53.6C42.5,37.7,39.8,40,37.3,40z M35.9,33.5v-50.1h-72v50.1H35.9z  M12.2,17.7L-1,25.3l-13.2-7.6v-0.2L-1,9.8L12.2,17.7z M0.5,7.6V-7.7L13.6,0v15.3L0.5,7.6z M-2.2,7.6l-13.2,7.7V0l13.2-7.7 L-2.2,7.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_1_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Azure_VM"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 38.4,
    y: 20,
    width: 53.1,
    height: 50
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_2_)"
    }
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    width: 85,
    height: 80,
    x: -42.5,
    y: -40,
    transform: "matrix(0.625 0 0 -0.625 64.9809 45)",
    style: {
      overflow: "visible"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureVirtual);
export default __webpack_public_path__ + "static/media/AzureVirtual.7a28fd729a81a6c2b31931e6c4681b5e.svg";
export { ForwardRef as ReactComponent };